import { getIconByDatastoreType } from "../DatastoreImage";
import { DatastoreTypeEnum } from "../../types";
import { DatastoreConfig } from "./types";

export type EnabledDatastoreType =
  | DatastoreTypeEnum.SNOWFLAKE
  | DatastoreTypeEnum.TABLEAU
  | DatastoreTypeEnum.DBT_CLOUD
  | DatastoreTypeEnum.DBT_CORE
  | DatastoreTypeEnum.AZURE_DATABRICKS
  | DatastoreTypeEnum.AZURE_DATABRICKS_PRIVATE_LINK
  | DatastoreTypeEnum.DATABRICKS;

export const DATASTORE_CONFIG: Record<EnabledDatastoreType, DatastoreConfig> = {
  [DatastoreTypeEnum.SNOWFLAKE]: {
    name: "Snowflake",
    value: DatastoreTypeEnum.SNOWFLAKE,
    formSteps: ["Type", "Connection", "Configuration"],
    icon: () =>
      getIconByDatastoreType({
        datastoreType: DatastoreTypeEnum.SNOWFLAKE,
        className: "al-w-10 al-h-10 al-mr-3",
      }),
  },
  [DatastoreTypeEnum.TABLEAU]: {
    name: "Tableau",
    value: DatastoreTypeEnum.TABLEAU,
    formSteps: ["Type", "Connection"],
    icon: () =>
      getIconByDatastoreType({
        datastoreType: DatastoreTypeEnum.TABLEAU,
        className: "al-w-10 al-h-10 al-mr-3",
      }),
  },
  [DatastoreTypeEnum.DBT_CLOUD]: {
    name: "dbt Cloud",
    value: DatastoreTypeEnum.DBT_CLOUD,
    formSteps: ["Type", "Connection", "Schedule"],
    icon: () =>
      getIconByDatastoreType({
        datastoreType: DatastoreTypeEnum.DBT_CLOUD,
        className: "al-w-10 al-h-10 al-mr-3",
      }),
  },
  [DatastoreTypeEnum.DBT_CORE]: {
    name: "dbt Core",
    value: DatastoreTypeEnum.DBT_CORE,
    formSteps: ["Type", "Connection"],
    icon: () =>
      getIconByDatastoreType({
        datastoreType: DatastoreTypeEnum.DBT_CORE,
        className: "al-w-10 al-h-10 al-mr-3",
      }),
  },
  [DatastoreTypeEnum.AZURE_DATABRICKS]: {
    name: "Azure Databricks Connection",
    value: DatastoreTypeEnum.AZURE_DATABRICKS,
    formSteps: ["Type", "Connection"],
    icon: () =>
      getIconByDatastoreType({
        datastoreType: DatastoreTypeEnum.AZURE_DATABRICKS,
        className: "al-w-10 al-h-10 al-mr-3",
      }),
  },
  [DatastoreTypeEnum.AZURE_DATABRICKS_PRIVATE_LINK]: {
    name: "Azure Databricks Private Link",
    value: DatastoreTypeEnum.AZURE_DATABRICKS_PRIVATE_LINK,
    formSteps: ["Type", "Connection"],
    icon: () =>
      getIconByDatastoreType({
        datastoreType: DatastoreTypeEnum.AZURE_DATABRICKS_PRIVATE_LINK,
        className: "al-w-10 al-h-10 al-mr-3",
      }),
  },
  [DatastoreTypeEnum.DATABRICKS]: {
    name: "Databricks",
    value: DatastoreTypeEnum.DATABRICKS,
    formSteps: ["Type", "Connection"],
    icon: () =>
      getIconByDatastoreType({
        datastoreType: DatastoreTypeEnum.DATABRICKS,
        className: "al-w-10 al-h-10 al-mr-3",
      }),
  },
};
